import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";
import { VcsIntegrationUser } from "types/generated";

const IntegrationsVcsUsedByTableNameCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<VcsIntegrationUser>) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={`/${item.isModule ? "module" : "stack"}/${item.stackId}`}
        onPress={() =>
          trackAnalytics("Stack link clicked", {
            name: item.stackName,
            type: item.isModule ? "module" : "stack",
          })
        }
      >
        {item.stackName}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default IntegrationsVcsUsedByTableNameCell;
